<template>
  <div>
    <ed-exame :intExameId="$route.params.intId" :key="$root.$session.versao"/>
  </div>
</template>

<script>
import EdExame from "@/components/cadastro/exame/editar";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {EdExame },
  mounted() {
    if(!this.$route.params.intId){
      this.$router.push({ name: "cadastro.funcao.register" });
    }
  },
  created() {},
  data() {
    return {
    };
  },
  methods: {
  
  },
};
</script>